import React from 'react';
import {
  BrListItemImage,
  BrListItemLabel,
  BrListItemWrapper,
} from '@app/ui/pages/landing-page/br-list/br-item/br-item.styles';
import { BrItemProps } from '@app/ui/pages/landing-page/br-list/br-item/br-item.types';

export const BrItem: React.FC<BrItemProps> = (props) => {
  const { caption, image } = props;

  return (
    <BrListItemWrapper>
      <BrListItemImage src={image} />
      <BrListItemLabel variant='body2'> {caption} </BrListItemLabel>
    </BrListItemWrapper>
  );
};
